
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppCarAutocomplete from "@/components/cars/CarAutocomplete.vue";
import { AuthService } from "@/services";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		modalOpen():boolean {
			return this.state.carSelectData.isOpen && AuthService.hasModule(MODULE.WAGENPARKBEHEER_PLUS_AUTOKOSTEN);
		},
	},
	watch: {
		"state.carSelectModalOpen": {
			immediate: true,
			handler(){
				if (!this.state.carSelectData.isOpen) return;
				this.state.carSelectData.car = this.state.sale.Car;
				this.state.carSelectData.mileage = this.state.sale.CarMileage;
			}
		}
	},
	methods: {
		cancel(){
			this.state.carSelectData.isOpen = false;
		},
		async confirm(){
			if (this.state.carSelectData.car) {
				if (this.state.carSelectData.car.ContactID) {
					let contact = await this.state.getContactService().getContact(this.state.carSelectData.car.ContactID);
					await this.state.selectContact(contact);
				}
				this.state.sale.CarID = this.state.carSelectData.car.ID;
				this.state.sale.Car = this.state.carSelectData.car;
				this.state.sale.CarMileage = this.state.carSelectData.mileage;
			}else{
				this.state.sale.CarID = null;
				this.state.sale.Car = null;
				this.state.sale.CarMileage = 0;
			}
			this.state.carSelectData.isOpen = false;
		}
	},
	components: {
		AppCarAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
